import { Button, ButtonProps } from 'react-bootstrap'
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf, faSpinner } from '@fortawesome/free-solid-svg-icons'
import fileDownload from 'js-file-download'

interface Props extends ButtonProps {
  calculationId: number
}

export function ExportPDFButton(props: Props) {
  const { calculationId, ...otherProps } = props
  const [exportPDFDisabled, setExportPDFDisabled] = useState(false)

  return (
    <Button
      onClick={() => {
        // Prevent the user double clicking the button
        setExportPDFDisabled(true)

        fetch(`/api/ghg/v1/calculation/${calculationId}/pdf`)
          .then(async (response) => {
            if (response.ok) {
              const blob = await response.blob()

              // Use the original filename if supplied
              const contentDisposition = response.headers.get('content-disposition')
              const fileName =
                contentDisposition && contentDisposition.indexOf('filename=') !== -1
                  ? contentDisposition.split('filename=')[1].replaceAll('"', '')
                  : 'GHG-Calculation.pdf'

              fileDownload(blob, fileName)
            } else {
              console.log('Error downloading PDF')
            }
          })
          .finally(() => {
            setExportPDFDisabled(false)
          })
      }}
      disabled={exportPDFDisabled}
      {...otherProps}
    >
      {exportPDFDisabled ? (
        <FontAwesomeIcon className="fa-spin" icon={faSpinner} />
      ) : (
        <FontAwesomeIcon color="red" icon={faFilePdf} />
      )}
    </Button>
  )
}
